import styled from '@emotion/styled'
import { FusionInterfaceZIndex } from '../../../theme/FusionStyle'

export const V2L1ModalUnderlay = styled.div(({theme}) => ({
	position: 'fixed',
	width: '100vw',
	height: '100vh',
	top: 0,
	left: 0,
	zIndex: FusionInterfaceZIndex.Modal,
	backgroundColor: theme.colors.modalUnderlay,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
}))
